// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[td-width-30][data-v-2298b347] {\n  width: 30%;\n}\n[td-width-60][data-v-2298b347] {\n  width: 60%;\n}\n#btn-deliver[data-v-2298b347] {\n  display: flex;\n  -moz-column-gap: 8px;\n       column-gap: 8px;\n  align-items: center;\n  padding: 0.25em 1.25em;\n}\n#btn-deliver .icon[data-v-2298b347] {\n  width: auto;\n}", ""]);
// Exports
module.exports = exports;
